import { useQuery, UseQueryOptions } from 'react-query';
import { ContextlessQueryObserverOptions } from '@frontend/react-query-helpers';
import { Unpromise } from '@frontend/types';
import { BusinessInfoApi } from '.';

const defaultOptions: ContextlessQueryObserverOptions = {
  refetchOnMount: true,
  refetchOnWindowFocus: false,
};

export const queryKeys = {
  base: ['business-information'],
  getLocationTcrBrand: (locationId: string) => [...queryKeys.base, 'getLocationTcrBrand', locationId],
};

export const useLocationTcrBrand = (
  locationId: string,
  options?: UseQueryOptions<Unpromise<ReturnType<typeof BusinessInfoApi.getLocationTcrBrand>>>
) => {
  return useQuery({
    ...defaultOptions,
    queryKey: queryKeys.getLocationTcrBrand(locationId),
    queryFn: () => BusinessInfoApi.getLocationTcrBrand({ locationId }),
    ...options,
    enabled: options?.enabled === undefined ? !!locationId : options.enabled && !!locationId,
  });
};
